import { auth } from '@/firebase'
import {
  multiFactor,
  PhoneAuthProvider,
  PhoneMultiFactorGenerator
} from 'firebase/auth'

export async function verifyNewPhoneNumber({ phoneNumber, recaptchaVerifier }) {
  const session = await multiFactor(auth.currentUser).getSession()
  const phoneOptions = {
    phoneNumber,
    session
  }
  return verifyPhoneNumberForOptions(phoneOptions, recaptchaVerifier)
}

export async function verifyPhoneNumberForResolver({
  resolver,
  recaptchaVerifier,
  hintIndex = 0
}) {
  const phoneOptions = {
    multiFactorHint: resolver.hints[hintIndex],
    session: resolver.session
  }
  return verifyPhoneNumberForOptions(phoneOptions, recaptchaVerifier)
}

async function verifyPhoneNumberForOptions(phoneOptions, recaptchaVerifier) {
  const phoneAuthProvider = new PhoneAuthProvider(auth)
  return phoneAuthProvider.verifyPhoneNumber(phoneOptions, recaptchaVerifier)
}

export function createMfaAssertion({ verificationId, verificationCode }) {
  const credential = PhoneAuthProvider.credential(
    verificationId,
    verificationCode
  )
  return PhoneMultiFactorGenerator.assertion(credential)
}

export async function enableMfa({ verificationId, verificationCode }) {
  await multiFactor(auth.currentUser).enroll(
    createMfaAssertion({ verificationId, verificationCode })
  )
}

export async function verifyMfa({
  resolver,
  verificationId,
  verificationCode
}) {
  return resolver.resolveSignIn(
    createMfaAssertion({ verificationId, verificationCode })
  )
}
